/**
 * @author lifei
 * 功能：商品中心
 */

//import * as func from '@/func'
import { enumToListV } from '@/func/enumToMap'

// const enumToList = func.enumToList()

/**
 * 功能：map spu状态 0：正常 1：作废
 */
export enum MapSpuCommodityStatus {
  正常 = 0,
  作废 = 1,
}

/**
 * 功能：map spu状态 0：正常 1：作废
 */
export enum MapSpuCommodityStatusColor {
  green,
  red,
}

export const ListSpuCommodityStatus = Object.freeze(enumToListV(MapSpuCommodityStatus))

/**
 * 功能：sku状态 map 0：正常 1：作废
 */
export enum MapSkuCommodityStatus {
  正常 = 0,
  作废 = 1,
}

export const ListSkuCommodityStatus = Object.freeze(enumToListV(MapSkuCommodityStatus))

/**
 * 功能：商品类型  map 1：图书:2：非图:3：组合4：加工:5：卡券:6：服务:7：虚拟:）
 */
export enum MapCommodityType {
  图书 = 1,
  非图 = 2,
  组合 = 3,
  加工 = 4,
  卡券 = 5,
  服务 = 6,
  虚拟 = 7,
}

export const ListCommodityType = enumToListV(MapCommodityType)

/**
 * 功能：	编目状态 map（1：待生效、2：简编、3：初编、4：精编）
 */
export enum MapCatalogueStatus {
  待生效 = 1,
  简编,
  初编,
  精编,
}

/**
 * 功能：	编目状态 map（1：待生效 lime、2：简编 orange、3：初编 blue、4：精编 green）
 */
export enum MapCatalogueStatusColor {
  'purple' = 1,
  'orange',
  'blue',
  'green',
}

export const ListCatalogueStatus = Object.freeze(enumToListV(MapCatalogueStatus))

/**
 * 功能： 图书类型 map  1：普通图书、2：教材 3：图片活页 4：期刊杂志 5：进口图书
 */
export enum MapBooksType {
  普通图书 = 1,
  教材 = 2,
  图片活页 = 3,
  期刊杂志 = 4,
  进口图书 = 5,
}

export const ListBooksType = enumToListV(MapBooksType)

/**
 * 功能：是否有主图，map 0.无，1.有
 */
export enum MapIsMainImage {
  无 = 0,
  有 = 1,
}

export const ListIsMainImage = Object.freeze(enumToListV(MapIsMainImage))

/**
 * 功能：单位
 */
export enum MapUnit {
  件 = 1,
  箱 = 2,
  吨 = 3,
  套 = 4,
  包 = 5,
  台 = 6,
}

export const ListUnit = Object.freeze(enumToListV(MapUnit))

//  启用禁用枚举
export enum MapEdStatus {
  已启用 = 0,
  已禁用 = 1,
}
export const ListEdStatus = Object.freeze(enumToListV(MapEdStatus))

//  属性格式枚举
/**
 * 1单行文本 2多行文本 3数字 4枚举值（单选） 5枚举值（多选）6日期格式1（年月）7日期格式1（年月日）8日期格式2（年月日-时分秒）
 * 9.图片（单选）10.图片（多选）11.视频（单个）12.视频（多个）13.文件14.数据源（单选）15.数据源（多选）
 */
export enum MapAttributesFormat {
  TEXT_SING = 1,
  TEXT_MUL = 2,
  NUM = 3,
  ENUM_SING = 4,
  ENUM_MUL = 5,
  DATE_FORMAT_YM = 6,
  DATE_FORMAT_YMD = 7,
  DATE_FORMAT_YMDHMS = 8,
  IMG_SING = 9,
  IMG_MUL = 10,
  VIDEO_SING = 11,
  VIDEO_MUL = 12,
  FILE = 13,
  DATA_SING = 14,
  DATA_MUL = 15,
  SINGLE_AUDIO = 16,
  MULTI_AUDIO = 17,
}

export enum MapAttributesFormatName {
  TEXT_SING = '单行文本',
  TEXT_MUL = '多行文本',
  NUM = '数字',
  ENUM_SING = '枚举值（单选）',
  ENUM_MUL = '枚举值（多选）',
  DATE_FORMAT_YM = '日期格式1（年月）',
  DATE_FORMAT_YMD = '日期格式1（年月日）',
  DATE_FORMAT_YMDHMS = '日期格式2（年月日-时分秒）',
  IMG_SING = '图片（单选）',
  IMG_MUL = '图片（多选）',
  VIDEO_SING = '视频（单个）',
  VIDEO_MUL = '视频（多个）',
  FILE = '文件',
  DATA_SING = '数据源（单选）',
  DATA_MUL = '数据源（多选）',
  SINGLE_AUDIO = '音频（单个）',
  MULTI_AUDIO = '音频（多个）',
}

// attributesFormat

/**
 * 功能：数据来源
 * 1：供应商协同平台，
 * 2：三方系统，
 * 3：编目系统（针对图书），
 * 4：ERP销售中心，
 * 5：ERP采购中心，
 * 6：ERP商品中心编目新建，
 * 7 ERP商品中心预编目新建
 * 8:ERP商品中心自编新建
 * 9:其他
 */
export enum MapDataSource {
  供应商协同平台 = 1,
  三方系统,
  编目系统,
  ERP销售中心,
  ERP采购中心,
  ERP商品中心编目新建,
  ERP商品中心预编目新建,
  ERP商品中心自编新建,
  其他,
}

/**
 * 功能：卡券类型（1：充值卡，2：提货券）
 */
export enum MapCouponsType {
  充值卡 = 1,
  提货券,
}
export const ListCouponsType = enumToListV(MapCouponsType)

export enum MapMaterialObjectBatchManage {
  否,
  是,
  不启用,
}
export const ListMaterialObjectBatchManage = enumToListV(MapMaterialObjectBatchManage)

// 类目已关联商品不能删除
export enum MapCanBeRemove {
  可删除,
  不可删除,
}

// 是否固定字段
export enum MapIsImmobilization {
  否,
  是,
}

//  0-否，1-是  是否实物/是否周期订阅/是否固定字段
export enum MapYesOrNo {
  否,
  是,
}
export const ListYesOrNo = enumToListV(MapYesOrNo)

// 属性值是否必填 0-非必填 1-必填
export enum MapAttributesRequired {
  非必填,
  必填,
}
export const ListAttributesRequired = enumToListV(MapAttributesRequired)

// 组合类型  （1、实物组合；2、虚拟组合）
export enum MapCombinationType {
  实物组合 = 1,
  虚拟组合,
}
export const ListCombinationType = enumToListV(MapCombinationType)

// 编辑类型: 基础数据（类目/基础信息/商品参数初编），精编（商品参数精编/详细信息），业务信息，规格信息
export enum MapUpDateType {
  BASE,
  REFINED,
  BUSINESS,
  SPECIFICATION,
}

/**
 * 审核状态（1：审核中、2：已驳回、3：已通过、4：已撤销）
 */
export enum MapAuditStatus {
  审核中 = 1,
  已驳回,
  已通过,
  已撤销,
}
/**
 * 审核状态颜色（1：审核中 blue 、2：已驳回 red、3：已通过 green、4：已撤销 lime））
 */
export enum MapAuditStatusColor {
  'blue' = 1,
  'red' = 2,
  'green' = 3,
  'lime' = 4,
}

// 审读状态
export enum MapReviewStatus {
  未审读 = 1,
  可引进,
  不可引进,
  处理后可发货,
  可引进需到货后审读,
  可引进需到货后重点审读,
}
export const ListReviewStatus = enumToListV(MapReviewStatus)

// 是否通用 isCommon  编目/预编目 -- 通用 0,  省店自编 -- 1, 自编 -- 2
export enum MapIsCommon {
  通用,
  省店自编,
  自编,
}

// 数据源 1：版别，2：人员信息，3：奖项，4：开本，5：书目等级，6：年龄段，7：装帧，8：语种，9：国籍，10：读者类型，11：发行范围，12：版地，13：丛套书标识
export enum MapDataSourceType {
  版别 = 1,
  人员信息,
  奖项,
  开本,
  书目等级,
  年龄段,
  装帧,
  语种,
  国籍,
  读者类型,
  发行范围,
  版地,
  丛套书标识,
}
export const ListDataSourceType = enumToListV(MapDataSourceType)
